import axios from '@/api/config/request'
import { BASE_API } from './index'


export function logout() {
  return axios({
    url: `${BASE_API}/user/logout`,
    method: 'POST'
  })
}